<!-- 画面全体：縦横中央寄せ -->
<div class="search-wrapper">
  <!-- gif〜search-card をひとまとまりにしたグループ -->
  <div class="search-group">
    <!-- ヘッダー -->
    <div class="search-header">
      <!-- <div class="headline-group">
        <p class="headline-sub">Ready to join us?</p>
        <p class="headline-main">Search your Company!</p>
      </div> -->
      <div class="headline-group">
        <div class="headline-en">Ready to join us? Search your Company!</div>
        <p class="headline-sub">さあ、一緒に始めましょう！</p>
        <p class="headline-sub">まずはあなたの会社を教えてください。</p>
      </div>
      <div class="gif-placeholder">
        <video class="gif-placeholder__video" autoplay [muted]="true" loop playsinline preload="auto">
          <source src="assets/video/welcome.mp4" type="video/mp4" />
        </video>
      </div>
      <!-- <div class="headline-group">
        <div class="headline-jp">さあ、一緒に始めましょう！まずはあなたの会社を教えてください。</div>
      </div> -->
    </div>

    <!-- カード（高さ固定） -->
    <div class="search-card">
      <!-- タブ -->
      <div class="tabs" role="tablist">
        <button
          class="tab"
          [class.tab--active]="activeTab === 'corporate-number'"
          (click)="selectTab('corporate-number')"
          role="tab"
          [attr.aria-selected]="activeTab === 'corporate-number'"
        >
          法人番号で検索
        </button>
        <button
          class="tab"
          [class.tab--active]="activeTab === 'prefecture'"
          (click)="selectTab('prefecture')"
          role="tab"
          [attr.aria-selected]="activeTab === 'prefecture'"
        >
          都道府県で検索
        </button>
      </div>

      <!-- ─── 法人番号で検索 ─── -->
      @if (activeTab === 'corporate-number') {
        <div class="panel" role="tabpanel">
          <!-- 13桁入力フィールド -->
          <div class="digit-inputs" aria-label="法人番号（13桁）">
            @for (digit of digits; track $index) {
              <input
                #digitInput
                type="text"
                inputmode="numeric"
                maxlength="1"
                class="digit-input"
                [class.digit-input--filled]="digit !== ''"
                [value]="digit"
                (input)="onInput($event, $index)"
                (keydown)="onKeydown($event, $index)"
                (paste)="onPaste($event, $index)"
                [attr.aria-label]="$index + 1 + '桁目'"
                autocomplete="off"
              />
            }
          </div>

          <!-- 補助テキスト -->
          <p class="help-text">
            法人番号がわからない方は
            <a href="https://www.houjin-bangou.nta.go.jp/" target="_blank" rel="noopener noreferrer"> こちら🔗 </a>
          </p>

          <!-- ペーストボタン（クリップボードの内容に応じてラベル・状態が変化） -->
          <button
            class="paste-btn"
            [class.paste-btn--disabled]="isPasteDisabled"
            [disabled]="isPasteDisabled"
            (click)="pasteFromClipboard()"
            type="button"
            [attr.title]="isPasteDisabled ? 'クリップボードに数字がありません' : null"
          >
            {{ pasteButtonLabel }}
          </button>

          <!-- 高さ固定のための結果エリア -->
          <div class="results-area">
            <!-- ローディング -->
            @if (isLoading) {
              <div class="status-message loading"><span class="spinner"></span>検索中...</div>
            }

            <!-- エラー -->
            @if (!isLoading && errorMessage) {
              <p class="status-message error">{{ errorMessage }}</p>
            }

            <!-- 検索結果ボタン -->
            @if (!isLoading && results.length > 0) {
              <div class="results-buttons">
                @for (result of results; track result.corporateNumber) {
                  <button class="company-btn" type="button" (click)="onCompanyClick(result)">
                    {{ result.organizationFormalName }}
                  </button>
                }
              </div>
            }

            <!-- 結果なし -->
            @if (!isLoading && searched && results.length === 0 && !errorMessage) {
              <p class="status-message no-result">該当する法人が見つかりませんでした。</p>
            }
          </div>
          <!-- /results-area -->
        </div>
        <!-- /panel -->
      }

      <!-- ─── 都道府県で検索 ─── -->
      @if (activeTab === 'prefecture') {
        <div class="panel" role="tabpanel">
          <p class="coming-soon">🏗️ 都道府県検索は準備中です。</p>
        </div>
      }
    </div>
    <!-- /search-card -->
  </div>
  <!-- /search-group -->
</div>
<!-- /search-wrapper -->
